// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2XgEk","empty":"ModalGraph_empty__30JkL"};